<template>
  <div class="bill-detail-srm">
    <div class="ui-card ui-card-body" v-loading="isLoading">
      <el-table :data="dayPriceInfo">
        <el-table-column
          v-for="item in listDataMap"
          :key="item.prop"
          :prop="item.prop === 'priceIdName' ? 'priceId' : item.prop"
          :label="item.label"
          min-width="140"
        />
      </el-table>
      <div class="el-row"></div>
      <el-table :data="dataList" v-if="dataList.length > 0">
        <el-table-column
          v-for="item in detailDataMap"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          min-width="150"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import filtersFormatDate from '@/mixins/filtersFormatDate'
import { listDataMap, detailDataMap } from '@/enums/dataMap_billDetail'

export default {
  mixins: [filtersFormatDate],

  data() {
    return {
      dayPriceInfo: [],
      dataList: [],
      errorMsg: '',
      isLoading: false,
      query: null,
      listDataMap,
      detailDataMap,
    }
  },

  created() {
    this.query = this.$route.query
    this.fetchPriceInfo()
    this.fetchList()
  },

  methods: {
    // price info
    fetchPriceInfo() {
      const params = {
        actualDay: this.query.actualDay,
        validDate: this.query.day,
        supplierId: this.query.sid,
        cityCode: this.query.cityCode,
        priceId: this.query.id,
      }
      if (!params.actualDay || !params.validDate || !params.priceId) {
        return this.$message.error('缺少必要参数，请返回重试')
      }
      this.isLoading = true
      this.fetch
        .get('srm_settlementDataQueryById', { params })
        .then(res => {
          this.isLoading = false
          this.dayPriceInfo.push(res.data)
        })
        .catch(res => {
          this.isLoading = false
        })
    },

    // fetch data list
    fetchList() {
      const params = {
        actualDate: this.query.actualDay,
        validDate: this.query.day,
        bizLine: this.query.bizLine,
        priceId: this.query.id,
        adjustId: this.query.adjustId,
        supplierId: this.query.sid,
        cityCode: this.query.cityCode,
        pageSize: 100000,
        pageNo: 1,
      }
      if (!params.actualDate || !params.validDate || !params.bizLine || !params.priceId) {
        return this.$message.error('缺少必要参数，请返回重试')
      }
      this.isLoading = true
      this.fetch
        .get('srm_settlementDataDetail', { params })
        .then(res => {
          this.isLoading = false
          this.dataList = res.data || []
        })
        .catch(res => {
          this.isLoading = false
        })
    },
  },
}
</script>
